import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { LocationGridDataService } from 'common/services/data-services/admin/location/location-grid-data.service';
import { ViewTypesDataService } from 'common/services/data-services/admin/view-type/view-types-data.services';
import { CompiledReportsDataService } from 'common/services/data-services/admin/reports/compiled-reports.service';
import { CompiledReportsModel } from 'common/models/page-models/reports/compiled-reports/compiled-data-model';
import { CompiledReportsGridMetaModel } from 'common/models/page-models/reports/compiled-reports/compiled-grid-meta-model';
import { CompiledReportsListingModel } from 'common/models/page-models/reports/compiled-reports/compiled-grid-model';
import { TypesGridDataService } from 'common/services/data-services/admin/types/types-grid-data.services';
import { TypesListDataService } from 'common/services/data-services/custom-service/types-service';


@Injectable({
    providedIn: 'root'
})
export class CompiledReportsWidgetService extends GridWidgetService<CompiledReportsModel, CompiledReportsListingModel> {
    constructor(protected override ds: CompiledReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService, private locationListService: LocationGridDataService, private typesListService: TypesListDataService, private categoryListService: ViewTypesDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new CompiledReportsGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: CompiledReportsListingModel, metaModel: CompiledReportsGridMetaModel, routeData: WidgetModel): Promise<CompiledReportsGridMetaModel> {
        return new Promise<CompiledReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            this.locationListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedLocation.options = data.details;
            });
            this.typesListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedType.options = data.details;
            });
          
            resolve(metaModel);
        });
    }

}